"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get IEmailAdapter () {
        return _IEmailAdapter.default;
    },
    get IStorageAdapter () {
        return _IStorageAdapter.default;
    },
    get IStorageAdapterV2 () {
        return _IStorageAdapterV2.default;
    },
    get IWebhookNotificationAdapter () {
        return _IWebhookNotificationAdapter.default;
    },
    get XcEmail () {
        return _IEmailAdapter.XcEmail;
    },
    get XcEmailAttachment () {
        return _IEmailAdapter.XcEmailAttachment;
    },
    get XcEmailPlugin () {
        return _XcEmailPlugin.default;
    },
    get XcFile () {
        return _IStorageAdapter.XcFile;
    },
    get XcPlugin () {
        return _XcPlugin.default;
    },
    get XcPluginConfig () {
        return _XcPluginConfig.default;
    },
    get XcPluginHooks () {
        return _XcPluginHooks.default;
    },
    get XcPluginMigration () {
        return _XcPluginMigration.default;
    },
    get XcStoragePlugin () {
        return _XcStoragePlugin.default;
    },
    get XcWebhookNotificationPlugin () {
        return _XcWebhookNotificationPlugin.default;
    }
});
const _IEmailAdapter = /*#__PURE__*/ _interop_require_wildcard(require("./lib/IEmailAdapter"));
const _IStorageAdapter = /*#__PURE__*/ _interop_require_wildcard(require("./lib/IStorageAdapter"));
const _IStorageAdapterV2 = /*#__PURE__*/ _interop_require_default(require("./lib/IStorageAdapterV2"));
const _IWebhookNotificationAdapter = /*#__PURE__*/ _interop_require_default(require("./lib/IWebhookNotificationAdapter"));
const _XcEmailPlugin = /*#__PURE__*/ _interop_require_default(require("./lib/XcEmailPlugin"));
const _XcPlugin = /*#__PURE__*/ _interop_require_default(require("./lib/XcPlugin"));
const _XcPluginConfig = /*#__PURE__*/ _interop_require_default(require("./lib/XcPluginConfig"));
const _XcPluginHooks = /*#__PURE__*/ _interop_require_default(require("./lib/XcPluginHooks"));
const _XcPluginMigration = /*#__PURE__*/ _interop_require_default(require("./lib/XcPluginMigration"));
const _XcStoragePlugin = /*#__PURE__*/ _interop_require_default(require("./lib/XcStoragePlugin"));
const _XcWebhookNotificationPlugin = /*#__PURE__*/ _interop_require_default(require("./lib/XcWebhookNotificationPlugin"));
_export_star(require("./common/XcUIBuilder"), exports);
_export_star(require("./common/XcNotification"), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
